
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/zebra/thanks",
      function () {
        return require("private-next-pages/products/zebra/thanks.tsx");
      }
    ]);
  